import { render, staticRenderFns } from "./FacultyCoeEvaluations.vue?vue&type=template&id=53a241d3"
import script from "./FacultyCoeEvaluations.vue?vue&type=script&lang=js"
export * from "./FacultyCoeEvaluations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports